import type { UseFetchOptions } from 'nuxt/app'

export function useQuery<T>(
  url: string | (() => string),
  opts: Omit<UseFetchOptions<T>, 'default'> & { default?: () => T | Ref<T> }
) {
  const userStore = useUserStore()
  const { access_token } = storeToRefs(userStore)
  const config = useRuntimeConfig()

  return useFetch(url, {
    ...opts,
    baseURL: config.public.apiBaseUrl,
    async onRequest(res) {
      const { options } = res
      if (access_token) {
        options.headers = {
          ...options.headers,
          ...(!!access_token && {
            Authorization: 'Bearer ' + access_token.value
          })
        }
      }
      if (typeof opts?.onRequest === 'function') {
        await opts.onRequest(res)
      }
    },
    async onResponse(res) {
      if (typeof opts.onResponse === 'function') {
        await opts.onResponse(res)
      }
    },
    async onResponseError(res) {
      const { response } = res
      if (response.status === 401) {
        if (typeof opts.onResponseError === 'function') {
          await opts.onResponseError(res)
        }
      }
    }
  })
}
